import React from "react";
import cn from "classnames";
import styles from "./styles.css";

const Overlay = ({ className, ...rest }) => (
  <div
    {...rest}
    className={cn(styles.overlay, className)}
    aria-hidden="true"
    tabIndex={-1}
  />
);

export default Overlay;
